

export const windowOpenRecentId = "window.openRecent";